/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFiltrosPisos from './entidades/filtrosPisos';
import IPisos from './entidades/pisos';

export default class ModeloPisos {
    public consultarPisos() {
        return manejadorRest<IRespuesta<IPisos>>(() => negocio.get('Piso/ConsultarListaPiso'), true);
    }
    public crearPisos(pisos: IPisos) {
        return manejadorRest<IRespuesta<IPisos>>(() => negocio.post('Piso/GuardarPiso', pisos), true);
    }
    public editarPisos(pisos: IPisos) {
        return manejadorRest<IRespuesta<IPisos>>(() => negocio.put('Piso/EditarPiso', pisos), true);
    }
    public eliminarPisos(pisos: IPisos) {
        return manejadorRest<IRespuesta<IPisos>>(() => negocio.delete('Piso/EliminarPiso', pisos), true);
    }
    public consultarListaPisosPorFiltro(filtrosPisos: Partial<IPisos>) {
        return manejadorRest<IRespuesta<IPisos>>(
            () => negocio.post('Piso/ConsultarListaPisoPorFiltro', filtrosPisos),
            true
        );
    }
}
